import { Helmet } from '@dr.pogodin/react-helmet';
import { DEFAULT_PAGE_DESCRIPTION } from '../constants/pageMetadata';

const AppHelmetDefaults = () => {
	return (
		<Helmet>
			<title>
				Weight Loss and Longevity - ReadyRx
			</title>
			<meta name='description' content={DEFAULT_PAGE_DESCRIPTION} />
		</Helmet>
	);
};

export default AppHelmetDefaults;
